import { HtmlHTMLAttributes } from 'react';
import DOMPurify from 'dompurify';

type TagProps = 'div' | 'span' | 'p';

type RenderHtmlProps = {
    html?: string;
    className?: string;
    tag?: string;
    children?: React.ReactNode;
} & HtmlHTMLAttributes<HTMLDivElement>;

const RenderHtml = ({ html, className, tag = 'div', children, ...rest }: RenderHtmlProps): React.JSX.Element => {
    const Tag = tag as TagProps;
    if (children) {
        return (
            <Tag
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(children.toString(), { ADD_ATTR: ['target'] }) }}
                {...rest}
                className={className}
            />
        );
    }
    return (
        <Tag
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html ?? '', { ADD_ATTR: ['target'] }) }}
            {...rest}
            className={className}
        />
    );
};

export { RenderHtml };
export type { RenderHtmlProps };
